export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapRoadConditions';
export const ENTITY_EDIT_ROUTE = 'road-conditions/events/edit';
